import React from 'react';
import './StatisticsModal.css';

function StatisticsModal({ isOpen, onClose, goodieTypes, stats, employees }) {
  if (!isOpen) return null;

  return (
    <div className="stats-modal-overlay" onClick={onClose}>
      <div className="stats-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="stats-modal-header">
          <h2>Collection Statistics</h2>
          <button className="stats-modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="stats-modal-body">
          <div className="stats-grid">
            {goodieTypes.map(goodie => (
              <div key={goodie} className="stat-card">
                <h3>{goodie}</h3>
                <div className="stat-breakdown">
                  <div className="stat-item">
                    <span className="stat-label">Collected:</span>
                    <span className="stat-value delivered">{stats[goodie].delivered}</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-label">Returned:</span>
                    <span className="stat-value returned">{stats[goodie].returned}</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-label">Not Collected:</span>
                    <span className="stat-value not-delivered">{stats[goodie].notDelivered}</span>
                  </div>
                </div>
                <div className="stat-percentage">
                  Collected: {((stats[goodie].delivered / stats[goodie].total) * 100).toFixed(1)}%
                </div>
              </div>
            ))}
          </div>
          
          <div className="stats-summary">
            <h3>Overall Summary</h3>
            <div className="summary-grid">
              <div className="summary-item">
                <span className="summary-label">Total Employees:</span>
                <span className="summary-value">{employees.length}</span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Total Items Collected:</span>
                <span className="summary-value">
                  {goodieTypes.reduce((total, goodie) => total + stats[goodie].delivered, 0)}
                </span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Total Items Returned:</span>
                <span className="summary-value">
                  {goodieTypes.reduce((total, goodie) => total + stats[goodie].returned, 0)}
                </span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Overall Collection Rate:</span>
                <span className="summary-value">
                  {employees.length > 0 
                    ? ((goodieTypes.reduce((total, goodie) => total + stats[goodie].delivered, 0) / (employees.length * goodieTypes.length)) * 100).toFixed(1)
                    : 0}%
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StatisticsModal;
